import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface ICSBulkOrderDetailsInterface {
  reference: string
  bulkSlipNo?: any
  carrierService?: any
  status?: any
}

export const useGetICSBulkOrderDetails = () => {
  const mutate = useMutation(
    ({
      reference,
      bulkSlipNo,
      carrierService,
      status,
    }: ICSBulkOrderDetailsInterface) => {
      return postAPI(`ICSBulkConsignment/GetICSBulkOrderDetails`, {
        reference,
        bulkSlipNo,
        carrierService,
        status,
      })
    },
  )

  return mutate
}

export default useGetICSBulkOrderDetails
